
import { Directive } from '@angular/core';
import { Validator, NG_VALIDATORS } from '@angular/forms';
import { DateValidator } from './../validators/dateValidator';


@Directive({
selector: '[appCpfCnpjValidate][ngModel]',
providers: [{
provide: NG_VALIDATORS,
useExisting: DateValidatorDirective,
multi: true
}]
})
export class DateValidatorDirective extends DateValidator implements Validator {}